import React, { useEffect, useState } from 'react';
import * as Icons from 'react-bootstrap-icons';

import ConfirmationButton from '../../../app/components/ConfirmationButton';
import { CreateUpdateEmployeeRoleDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import CompanySelector from '../Selects/CompanySelector';
import TeamSelector from '../Selects/TeamSelector';
import BudgetSelector from '../Selects/BudgetSelector';
import { Option } from '../Selects/Selector';
import RoleSelector from '../Selects/RoleSelector';
import { useTranslation } from '../../../common/hooks/useTranslation';
import LastEditorInfo from '../../../app/components/LastEditorInfo';
import { usePokCore } from '../../../common/hooks/usePokCore';

export const EmployeeRole = (props: {
  value: CreateUpdateEmployeeRoleDto;
  onUpdate: (dto: CreateUpdateEmployeeRoleDto) => void;
  onDelete: () => void;
}) => {
  const [cuDto, setCuDto] = useState(props.value);
  const { t, tk } = useTranslation('roleLng');
  const pok = usePokCore();

  const propertyChange = (obj: Partial<CreateUpdateEmployeeRoleDto>) => {
    const newValue = { ...cuDto, ...obj };
    props.onUpdate(newValue);
  };

  useEffect(() => {
    setCuDto(props.value);
  }, [props.value]);

  return (
    <tr className="align-middle">
      <td>
        <RoleSelector
          value={cuDto.roleId}
          onChange={option =>
            propertyChange({ roleId: (option as Option).value })
          }
        />
      </td>
      <td>
        <CompanySelector
          value={cuDto.companyId}
          onChange={option => {
            propertyChange({
              companyId: (option as Option)?.value,
            });
          }}
          clearable
        />
      </td>
      <td>
        <TeamSelector
          value={cuDto.teamId}
          companyId={cuDto.companyId}
          onChange={option => {
            if (option) {
              propertyChange({ teamId: (option as Option)?.value });
            }
          }}
          clearable
        />
      </td>
      <td>
        <BudgetSelector
          value={cuDto?.budgetId}
          onChange={option => {
            if (option) {
              propertyChange({ budgetId: (option as Option)?.value });
            }
          }}
          clearable
        />
      </td>
      <td className="text-center align-middle">
        <ConfirmationButton
          confirmation={t(tk.role.askDeleteUserRole)}
          onOK={props.onDelete}
          variant="outline-danger"
        >
          <Icons.Trash />
        </ConfirmationButton>
      </td>

      <td className="text-center align-middle">
        {cuDto?.id && (
          <LastEditorInfo
            className="last-editor-inline"
            id={cuDto.id}
            method={pok.employeesRoles.getLastEditor}
          />
        )}
      </td>
    </tr>
  );
};
